import React from "react";
import TrendPanel from "./TrendPanel";
import ChannelPanel from "./ChannelPanel";
import { BEAUTY_TREND_METRICS, buildSeries, channelShares, choiceRows, collectionRows } from "./beautyStatsMetrics";
import { fmtInt, fmtLead, fmtMoney, fmtPct0 } from "./statsFormat";

/**
 * Evolución y canales tab of the Beauty statistics: the trend of one metric (occupancy, revenue or
 * appointments) for this period against the comparison period with a table twin, next to the
 * "Canal de reserva" panel: the channel stack, how clients choose their professional, how the money
 * of the period splits and how far ahead clients book.
 *
 * @param {{current: object, comparison: object|null, compareMode: string, bucket: number}} props
 *   `bucket` groups days (1 = daily, 7 = weekly average) to keep long ranges readable.
 */
export default function BeautyEvolucionTab({ current, comparison, compareMode, bucket }) {
  const choice = choiceRows(current.choice).map((row) => ({
    key: row.key,
    label: row.label,
    value: fmtInt(row.count),
    muted: fmtPct0(row.share),
  }));
  const collections = collectionRows(current.totals).map((row) => ({
    key: row.key,
    label: row.label,
    value: fmtMoney(row.amount),
    muted: fmtPct0(row.share),
  }));
  // Lead time closes the collections block: how far ahead clients book, and how many do it the same day.
  collections.push({
    key: "lead",
    label: "Anticipación promedio",
    value: fmtLead(current.totals.avgLeadHours),
    muted: `${fmtPct0(current.totals.sameDayShare)} el mismo día`,
  });

  return (
    <div className="stats-row-2">
      <TrendPanel
        current={current}
        comparison={comparison}
        compareMode={compareMode}
        bucket={bucket}
        buildSeries={buildSeries}
        metrics={BEAUTY_TREND_METRICS}
        countButton="Turnos"
      />
      <ChannelPanel
        channels={channelShares(current.channels)}
        subtitle="Por dónde entran los turnos y cómo eligen profesional."
        unit="turnos"
        emptyText="Sin turnos en el período."
        sections={[
          { title: "Cómo eligen profesional", rows: choice },
          { title: "Cobros del período", rows: collections },
        ]}
      />
    </div>
  );
}
